import React from 'react';
import { Link } from 'react-router-dom';

const proofChips = [
  'Artist profile saved',
  'Payment received',
  'Song link submitted',
  'Rights confirmations received',
];

const trustSpine = [
  'Payment gets your record processed.',
  'Excellence earns the next move.',
  'Placement cannot be bought.',
];

const ActionCue = ({ children }) => (
  <span className="hitlab-post-submit-action-cue">{children}</span>
);

export default function HitLabPostSubmitBridge({
  onShareHitLab,
  shareFallbackMessage = '',
  shareState = { message: '', showFallback: false },
}) {
  return (
    <article
      className="hitlab-receipt-card hitlab-receipt-card-wide hitlab-post-submit-bridge"
      aria-label="JG Universe post-submit bridge"
    >
      <div className="hitlab-post-submit-bridge-header">
        <div>
          <p className="hitlab-kicker">JG UNIVERSE</p>
          <h2>Enter JG Universe while HitLab reviews your record.</h2>
        </div>
        <Link
          className="hitlab-primary-btn"
          to="/home?source=hitlab-submitted"
        >
          Enter JG Universe
        </Link>
      </div>

      <div className="hitlab-post-submit-proof-wrap">
        <p className="hitlab-post-submit-proof-label">Your submission path</p>
        <ul
          className="hitlab-post-submit-proof"
          aria-label="HitLab submission proof"
        >
          {proofChips.map((chip) => (
            <li key={chip}>{chip}</li>
          ))}
        </ul>
      </div>

      <div className="hitlab-post-submit-trust" aria-label="HitLab trust spine">
        {trustSpine.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </div>

      <div className="hitlab-post-submit-core-actions" aria-label="JG Universe next steps">
        <Link
          className="hitlab-post-submit-action"
          to="/home?radio=1&source=hitlab-submitted"
        >
          <strong>Hear Joe Galaxy Radio</strong>
          <span>
            Joe Galaxy Radio is live inside JG Universe. Records in rotation
            can be discovered, heard, and reacted to by JG Players.
          </span>
          <ActionCue>Hear Radio -&gt;</ActionCue>
        </Link>

        <Link
          className="hitlab-post-submit-action"
          to="/profile/thejoegalaxy"
        >
          <strong>Connect with @thejoegalaxy</strong>
          <span>
            Find Joe Galaxy inside JG Universe. Follow the public profile, stay
            close to Radio movement, and see what is happening across the
            platform.
          </span>
          <ActionCue>View profile -&gt;</ActionCue>
        </Link>

        <Link
          className="hitlab-post-submit-action"
          to="/home?source=hitlab-first-post"
        >
          <strong>Make your first post</strong>
          <span>
            Tell people your record is in the JG HitLab review path. One
            record. One shot.
          </span>
          <ActionCue>Start on Home -&gt;</ActionCue>
        </Link>

        <button
          type="button"
          className="hitlab-post-submit-action"
          onClick={onShareHitLab}
        >
          <strong>Share JG HitLab</strong>
          <span>I submitted one record to JG HitLab. One record. One shot.</span>
          <ActionCue>Share HitLab -&gt;</ActionCue>
        </button>
      </div>

      <Link
        className="hitlab-post-submit-discovery"
        to="/localops/how-it-works?source=hitlab-submitted"
        aria-label="Explore JG LocalOps discovery"
      >
        <span>
          <strong>Explore JG LocalOps</strong>
          <span>
            Build proof beyond the record. JG LocalOps lets real people
            complete verified actions and build Action Credit through
            real-world work.
          </span>
        </span>
        <ActionCue>Explore LocalOps -&gt;</ActionCue>
      </Link>

      {shareState.message ? (
        <p className="hitlab-share-message">{shareState.message}</p>
      ) : null}
      {shareState.showFallback ? (
        <label className="hitlab-copy-field">
          JG HitLab share message
          <textarea
            readOnly
            value={shareFallbackMessage}
            onFocus={(event) => event.target.select()}
          />
        </label>
      ) : null}
    </article>
  );
}
